import React, { useState } from 'react';
import { Stack, TextField, MenuItem } from '@mui/material';
import { RateCardList } from '../../services/rateCardService';

export const cityOf = (c: string | null | undefined) => c || 'No city';

/** Zone picker: pick a city, then a zone in it. */
const ZonePicker: React.FC<{
  zones: RateCardList['zones']; excludeIds?: number[]; onPick: (zoneId: number) => void; label?: string;
}> = ({ zones, excludeIds = [], onPick, label = 'Zone' }) => {
  const cities = Array.from(new Set(zones.map((z) => cityOf(z.city)))).sort();
  const [city, setCity] = useState(cities[0] ?? '');
  const inCity = zones.filter((z) => cityOf(z.city) === city && !excludeIds.includes(z.id));
  return (
    <Stack spacing={2} sx={{ mt: 1 }}>
      <TextField select size="small" label="City" value={city} onChange={(e) => setCity(e.target.value)}>
        {cities.map((c) => <MenuItem key={c} value={c}>{c}</MenuItem>)}
      </TextField>
      <TextField select size="small" label={label} value="" onChange={(e) => onPick(Number(e.target.value))} disabled={inCity.length === 0}
                 helperText={inCity.length === 0 ? 'No more zones in this city' : undefined}>
        {inCity.map((z) => <MenuItem key={z.id} value={z.id}>{z.name}{z.isActive ? '' : ' (inactive)'}</MenuItem>)}
      </TextField>
    </Stack>
  );
};

export default ZonePicker;
